var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37555 23.9927 0.00717163 18.6245 0 12C0 5.37256 5.37259 0 12 0C18.6274 0 24 5.37256 24 12ZM10.806 9.10596L5.72099 11.8452C5.46243 11.9595 5.29485 12.2158 5.29485 12.4995C5.29485 12.7832 5.46243 13.04 5.722 13.1543L10.805 15.8853C11.0435 16.0254 11.3387 16.0288 11.58 15.8931C11.8154 15.7466 11.9534 15.4844 11.941 15.207V14.48C11.9406 14.3921 11.9866 14.3101 12.0622 14.2651C12.1378 14.2197 12.2316 14.2178 12.309 14.2603L15.329 15.8853C15.4534 15.9551 15.5934 15.9922 15.736 15.9941C15.8655 15.9946 15.9926 15.96 16.104 15.894C16.3387 15.7471 16.4761 15.4849 16.464 15.208V9.78027C16.4823 9.50195 16.3433 9.23682 16.1041 9.09375C15.8648 8.95068 15.5655 8.95361 15.329 9.10107L12.309 10.7271C12.2328 10.7705 12.1392 10.7705 12.063 10.7271C11.9874 10.6816 11.9411 10.6001 11.941 10.5122V9.78516C11.9593 9.50684 11.8203 9.2417 11.5811 9.09863C11.3418 8.95557 11.0425 8.9585 10.806 9.10596Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.f9172312.svg";
export { ForwardRef as ReactComponent };